import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import moment from 'moment';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { UtilityService } from '../../../core/services/utility.service';

@Component({
  selector: 'app-edit-scheduled-date-modal',
  templateUrl: './edit-scheduled-date-modal.component.html',
  styleUrls: ['./edit-scheduled-date-modal.component.css']
})
export class EditScheduledDateModalComponent {
  @Input() data: any
  formData: { [key: string]: any }
  portalSettings: any
  format: string
  datepickerOptions: any

  constructor(
    private ngbActiveModal: NgbActiveModal,
    private portalSettingsService: PortalSettingsService,
    private utilityService: UtilityService
  ) {
    this.portalSettings = this.portalSettingsService.getPortalSettings()
    this.format = this.utilityService.getDateFormat();
  }

  ngOnInit () {
    this.datepickerOptions = { dateInputFormat: this.format.toUpperCase(), containerClass: "theme-blue", showTodayButton: true, showClearButton: true, clearPosition: "left", showWeekNumbers: false }
    this.formData = {
      TripName: this.data.TripName,
      ScheduledDate: (this.data.ScheduledDate != null ? new Date(moment(this.data.ScheduledDate).utc().format('MM/DD/YYYY')) : null),
      TripDescription: this.data.TripDescription,
      ScheduledTime: null
    }

    if (this.data.ScheduledTime != null) {
      var temp = this.data.ScheduledTime.split(':');
      var hour = parseInt(temp[0]);
      var min = parseInt(temp[1].substring(0, 2));
      var meridiem = temp[1].substring(3, 5);
      if (hour == 12 && meridiem == "AM")
        hour = 0;
      else if (hour != 12 && meridiem == "PM")
        hour += 12;
      this.formData.ScheduledTime = new Date(2000, 1, 1, hour, min, 1);
    }
  }

  cancelClicked () {
    this.ngbActiveModal.dismiss();
  }

  saveClicked () {
    this.ngbActiveModal.close(this.formData);
  }
}
